import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { config } from "../utils/constants";
import { setEmail } from "../store/slices/auth.ts";
import { setOrderData, setPriceData } from "../store/slices/cartSlice.ts";

import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";

export default function CheckoutForm({
  charge_amount,
  shipping_amount,
  email,
  rates_id,
  carrier,
  service_level,
  applied_promotion_code,
}) {
  const REACT_APP_BASE_URL = config.url.REACT_APP_BASE_URL;
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const return_url = `${REACT_APP_BASE_URL}/payment-success/`;

  useEffect(() => {
    if (!stripe) return;

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) return;

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent?.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });
  }, [stripe]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);
    setMessage(null);

    dispatch(
      setEmail({
        email: `${email}`,
      })
    );

    dispatch(
      setOrderData({
        rates_id,
        shipping_price: parseFloat(shipping_amount || 0),
        taxes: 0,
        carrier,
        service_level,
        applied_promotion_code,
      })
    );

    dispatch(
      setPriceData({
        total_price: parseFloat(charge_amount || 0),
      })
    );

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url,
      },
    });

    if (error) {
      if (error.type === "card_error" || error.type === "validation_error") {
        setMessage(error.message);
      } else {
        setMessage("An unexpected error occurred.");
      }
    }

    setIsLoading(false);
  };

  return (
    <div className="card-body mx-md-4">
      <div className="text-center"></div>

      <form id="payment-form" onSubmit={handleSubmit}>
        <h4 style={{ fontWeight: "bold" }}>
          Amount to be charged: ${parseFloat(charge_amount || 0).toFixed(2)}
          <br />
          <br />
        </h4>

        <PaymentElement id="payment-element" />
        <br />

        <button
          type="submit"
          disabled={isLoading || !stripe || !elements}
          id="submit"
          className="btn btn-primary"
        >
          <span id="button-text">
            {isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}
          </span>
        </button>

        {message && <div id="payment-message">{message}</div>}
      </form>
    </div>
  );
}